import {
  Paper,
  Table,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

import { RobotoTableCell } from "@/shared/components";

import { type EvaluationColumn } from "./tableColumns";
import { TriggerEvaluationsPagination } from "./TriggerEvaluationsPagination";
import { TriggerEvaluationsTableBody } from "./TriggerEvaluationsTableBody";
import { useTriggerEvaluationsPagination } from "./useTriggerEvaluationsPagination";

interface TriggerEvaluationsForDatasetProps {
  datasetId: string;
}

const COLUMNS: Record<string, EvaluationColumn> = {
  Trigger: "trigger_id",
  Cause: "cause",
  "Evaluation Start": "evaluation_start",
  "Evaluation End": "evaluation_end",
  Status: "status",
  "Status Detail": "status_detail",
  Outcome: "outcome",
  Reason: "outcome_reason",
};

/*
 * Render a table of trigger evaluation records for the given dataset.
 */
export function TriggerEvaluationsForDataset({
  datasetId,
}: TriggerEvaluationsForDatasetProps) {
  const filter = { datasetId };
  const {
    page,
    rowsPerPage,
    evaluationsQuery,
    countQuery,
    handlePageChange,
    handleRowsPerPageChange,
  } = useTriggerEvaluationsPagination(filter);

  const headers = Object.entries(COLUMNS).map(([label, column]) => (
    <RobotoTableCell key={column}>{label}</RobotoTableCell>
  ));

  const totalCount = countQuery.data ?? evaluationsQuery.data?.length ?? 0;

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>{headers}</TableRow>
        </TableHead>
        <TriggerEvaluationsTableBody
          columns={Object.values(COLUMNS)}
          page={page}
          rowsPerPage={rowsPerPage}
          evaluationsQuery={evaluationsQuery}
        />
      </Table>
      <TriggerEvaluationsPagination
        page={page}
        rowsPerPage={rowsPerPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        hasNextPage={evaluationsQuery.hasNextPage ?? false}
        totalCount={totalCount}
      />
    </TableContainer>
  );
}
